<template>
  <div class="container">
    <img v-if="isShow" src="@/assets/img/down_wechat.jpg" class="wimg" />
  </div>
</template>

<script>
import systemApi from '@/api/system'

export default {
  data() {
    return {
      isShow: false,
    }
  },
  mounted() {
    this.goDownload();
  },
  methods: {
    // 去下载
    async goDownload() {
      const res = await systemApi.getConfig()
      var u = navigator.userAgent, app = navigator.appVersion;
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      // 是微信内部webView
      if (this.is_weixn()) {
        this.isShow = true
      }
      // 这里是安卓浏览器
      else if (isAndroid) {
        window.location.href = res.systemSetting.androidUrl
      }
      // 这里是iOS浏览器
      else if (isIOS) {
        window.location.href = res.systemSetting.iosUrl
      }
    },
    // 是微信浏览器
    is_weixn() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  background: #fff;
  text-align: center;

  .wimg {
    width: 350px;
  }
}
</style>
